import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { Label } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  label: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2.5,
    '& > span': {
      paddingRight: theme.spacing(2)
    }
  }
}));

export const InfoLabel = props => {
  const classes = useStyles();
  return (
    <Label className={classes.label} {...props} />
  );
};

InfoLabel.propTypes = {
  children: PropTypes.node
};

export default InfoLabel;
